import { topicItems } from '@/mocks/home';

const trendConfig: Record<string, { icon: string; cls: string }> = {
  hot: { icon: 'ri-fire-line', cls: 'text-primary-500' },
  up: { icon: 'ri-arrow-up-line', cls: 'text-accent-500' },
  new: { icon: 'ri-sparkling-line', cls: 'text-secondary-500' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门话题
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              全网热议的内容标签，看看大家都在关注什么
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {topicItems.map((item) => {
              const trend = trendConfig[item.trend];
              return (
                <a
                  key={item.id}
                  href="#media"
                  className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer group"
                >
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.heat}</span>
                  <i className={`${trend.icon} text-sm ${trend.cls}`}></i>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}